import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { formatDistanceToNow, format } from 'date-fns';
import { isValueEmpty } from '@awp/helpers/utilsReact';

const validImageViewStyle = 'border border-1 p-2 rounded';
const invalidImageViewStyle = 'border-danger border border-1 p-2 rounded';
const CameraViewWS = ({ CameraView }) => {
  const [valid, setValid] = useState(true);
  const [cameraImage, setCameraImage] = useState(null);
  const [cssBorder, setCSSBorder] = useState(validImageViewStyle);
  const [imageTS, setImageTS] = useState(0);
  const [noImage, setNoImage] = useState(false);
  const fetchCameraImage = useCallback(async (cameraId) => {
    const url = `/api/v1/camera-view/${cameraId}/image-latest`;
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return await res.json();
  });

  useEffect(() => {
    setCSSBorder(valid ? validImageViewStyle : invalidImageViewStyle);
  }, [valid]);

  useEffect(() => {
    fetchCameraImage(CameraView.Id).then((image) => {
      const dateTS = new Date(image.TimeStamp * 1000);
      setCameraImage(image.Url);
      setValid(dateTS > Date.now() - 60 * 60 * 1000);
      setImageTS(dateTS);
      if (image && isValueEmpty(image.Url)) setNoImage(true);
    });
  }, [CameraView]);

  return (
    <div className="col-sm-6 pb-3">
      <div className={cssBorder}>
        <div className="row">
          <div className="col-6">
            <h4 className="text-primary">
              {CameraView.Id} - {CameraView.Name}
            </h4>
            <p>{CameraView.Description}</p>
          </div>
          <div className="col-6">
            {cameraImage ? (
              <>
                <img src={cameraImage} className="col" />
                <div className="text-center small mt-2">
                  <p>
                    {format(imageTS, 'yyyy-MM-dd HH:mm')}
                    <br />
                    <span className={valid ? '' : 'text-danger'}>
                      {valid ? '' : <i className="bi bi-exclamation-circle-fill text-danger pr-2" />}
                      Last received {formatDistanceToNow(imageTS)} ago
                    </span>
                  </p>
                </div>
              </>
            ) : !noImage ? (
              <b>Loading image</b>
            ) : (
              <div className="text-center small mt-2">
                <p>
                  <span className={valid ? '' : 'text-danger'}>
                    {valid ? '' : <i className="bi bi-exclamation-circle-fill text-danger pr-2" />}
                    {'This highway cam image is currently unvailable.'}
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

CameraViewWS.propTypes = {
  CameraView: PropTypes.object.isRequired,
};

export default CameraViewWS;
